"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var network_1 = __importDefault(require("../../../network"));
var constants_1 = require("../constants");
var ElrondApi = /** @class */ (function () {
    function ElrondApi(API_URL) {
        this.API_URL = API_URL;
    }
    ElrondApi.prototype.getAccountDetails = function (addr) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, balance, nonce;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, (0, network_1["default"])({
                            method: "GET",
                            url: "".concat(this.API_URL, "/accounts/").concat(addr)
                        })];
                    case 1:
                        _a = (_b.sent()).data, balance = _a.balance, nonce = _a.nonce;
                        return [2 /*return*/, {
                                balance: balance,
                                nonce: nonce
                            }];
                }
            });
        });
    };
    ElrondApi.prototype.getValidators = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, validators, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, network_1["default"])({
                                method: "GET",
                                url: "".concat(this.API_URL, "/validator/statistics")
                            })];
                    case 2:
                        validators = (_a.sent()).data.validators;
                        data = validators;
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        return [2 /*return*/, data];
                    case 4: return [2 /*return*/, data];
                }
            });
        });
    };
    ElrondApi.prototype.getNetworkConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, chainId, denomination, gasLimit, gasPrice, gasPerByte;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, (0, network_1["default"])({
                            method: "GET",
                            url: "".concat(this.API_URL, "/network/config")
                        })];
                    case 1:
                        _a = (_b.sent()).data.data.config, chainId = _a.erd_chain_id, denomination = _a.erd_denomination, gasLimit = _a.erd_min_gas_limit, gasPrice = _a.erd_min_gas_price, gasPerByte = _a.erd_gas_per_data_byte;
                        return [2 /*return*/, {
                                chainId: chainId,
                                denomination: denomination,
                                gasLimit: gasLimit,
                                gasPrice: gasPrice,
                                gasPerByte: gasPerByte
                            }];
                }
            });
        });
    };
    ElrondApi.prototype.submit = function (_a) {
        var operation = _a.operation, signature = _a.signature;
        return __awaiter(this, void 0, void 0, function () {
            var _b, chainId, gasLimit, gasPrice, _c, sender, _d, receiver, value, nonce, hash;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, this.getNetworkConfig()];
                    case 1:
                        _b = _e.sent(), chainId = _b.chainId, gasLimit = _b.gasLimit, gasPrice = _b.gasPrice;
                        _c = __read(operation.senders, 1), sender = _c[0], _d = __read(operation.recipients, 1), receiver = _d[0], value = operation.value, nonce = operation.transactionSequenceNumber;
                        return [4 /*yield*/, (0, network_1["default"])({
                                method: "POST",
                                url: "".concat(this.API_URL, "/transaction/send"),
                                data: __assign({ nonce: nonce, value: value, receiver: receiver, sender: sender, gasPrice: gasPrice, gasLimit: gasLimit, chainID: chainId, signature: signature }, constants_1.HASH_TRANSACTION)
                            })];
                    case 2:
                        hash = (_e.sent()).data.data.txHash;
                        return [2 /*return*/, {
                                hash: hash
                            }];
                }
            });
        });
    };
    ElrondApi.prototype.getHistory = function (addr, startAt) {
        return __awaiter(this, void 0, void 0, function () {
            var transactionsCount, allTransactions, from, transactions;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, network_1["default"])({
                            method: "GET",
                            url: "".concat(this.API_URL, "/transactions/count?condition=should&sender=").concat(addr, "&receiver=").concat(addr, "&after=").concat(startAt)
                        })];
                    case 1:
                        transactionsCount = (_a.sent()).data;
                        allTransactions = [];
                        from = 0;
                        _a.label = 2;
                    case 2:
                        if (!(from <= transactionsCount)) return [3 /*break*/, 4];
                        return [4 /*yield*/, (0, network_1["default"])({
                                method: "GET",
                                url: "".concat(this.API_URL, "/transactions?condition=should&sender=").concat(addr, "&receiver=").concat(addr, "&after=").concat(startAt, "&from=").concat(from, "&size=").concat(constants_1.TRANSACTIONS_SIZE)
                            })];
                    case 3:
                        transactions = (_a.sent()).data;
                        allTransactions = __spreadArray(__spreadArray([], __read(allTransactions), false), __read(transactions), false);
                        from = from + constants_1.TRANSACTIONS_SIZE;
                        return [3 /*break*/, 2];
                    case 4: return [2 /*return*/, allTransactions];
                }
            });
        });
    };
    ElrondApi.prototype.getBlockchainBlockHeight = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, blockHeight;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, (0, network_1["default"])({
                            method: "GET",
                            url: "".concat(this.API_URL, "/blocks?shard=").concat(constants_1.METACHAIN_SHARD, "&fields=round")
                        })];
                    case 1:
                        _a = __read.apply(void 0, [(_b.sent()).data, 1]), blockHeight = _a[0].round;
                        return [2 /*return*/, blockHeight];
                }
            });
        });
    };
    return ElrondApi;
}());
exports["default"] = ElrondApi;
//# sourceMappingURL=apiCalls.js.map